import styled from '@emotion/styled'
import BrokenImageOutlinedIcon from "@mui/icons-material/BrokenImageOutlined"

const Styled = {
  Error: styled.div`
    width: 100%;
    height: 100%;
    border: 1px dotted ${({ theme }) => theme.colors.cloudyBlue};
    background-color: ${({ theme }) => theme.colors.darkIndigo};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      max-width: 75px;
      width: auto;
      height: 90%;
      opacity: 0.05;
    }
  `,
}

const ErrorImage = () => (
  <Styled.Error>
    <BrokenImageOutlinedIcon color="primary" />
  </Styled.Error>
)

export default ErrorImage
